<template>
  <ThemeProvider theme="campsite">
    <div id="outer-container">
      <Svgs />
      <SimpleHeader />
      <main id="main">
        <nuxt />
      </main>
      <SimpleFooter />
    </div>
  </ThemeProvider>
</template>

<script>
import { ThemeProvider } from '@campsite-bio/component-lib';

import SimpleHeader from '@/components/simple-header';
import SimpleFooter from '@/components/simple-footer';
const Svgs = () => import('@/components/svgs');
import intercom from '~/plugins/intercom';
import fbPixel from '~/plugins/facebook-pixel';

export default {
  components: {
    SimpleHeader,
    SimpleFooter,
    Svgs,
    ThemeProvider,
  },

  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://campsite.bio' + this.$route.path,
        },
      ],
    };
  },

  created() {
    setTimeout(() => {
      intercom(this.$nuxt.context);
    }, 1500);
  },
};
</script>

<style lang="scss" scoped></style>
